import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Space from "../commons/Space";
import {addNewRewardInActivity, fetchActivityWinRewards} from "../../actions/activitiesActions";
import {Button, Chip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import FormControl from "@material-ui/core/FormControl";
import {IMAGE_MAX_WIDTH_HEIGHT} from "../commons/FilePicker";
import {cloneDeep} from "lodash";
import {
  ColorActivityForm,
  ColorCardField,
  ColorCardFieldHover,
  ColorCardFieldSelected,
  ColorNegative,
  ColorTheme
} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  ACCEPTED_VIDEO_MIMES,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO
} from "../commons/SingleFilePicker";
import {getErrorFromResponse} from "../../utils/ApiHelper";
import TextView from "../commons/TextView";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import ProgressLoader from "src/js/components/commons/ProgressLoader";
import {GetViewForItem} from "src/js/components/activity/FunLists";
import Snackbar from "@material-ui/core/Snackbar";
import {ImageIcon, SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import MuiAlert from "@material-ui/lab/Alert";

const useStyles = (theme) => ({
  viewVouchersListField: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  viewRewardsListError: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: ColorFieldDisabled,
    borderRadius: BORDER_RADIUS,
    border: '1px solid red'
  },
  viewVouchersError: {
    margin: -8,
    padding: 8,
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: ColorActivityForm,
    borderRadius: BORDER_RADIUS,
    border: '1px solid red'
  },
  boxesCardReward: {
    position: 'relative',
    display: 'flex',
    // flex: 1,
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    },
  },
  boxesCardRewardDisabled: {
    position: 'relative',
    display: 'flex',
    // flex: 1,
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    opacity: 0.6,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    },
  },
  boxesCardRewardSelected: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    border: '2px solid '+ ColorTheme,
    backgroundColor: ColorCardFieldSelected,
    overflow: 'hidden',
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      border: '1px solid '+ ColorTheme,
      margin: 6,
    },
  },
  boxesCardButton: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    width: '100%',
    // flex: 1,
    margin: 10,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    }
  },
  boxesCardButtonContent: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  boxContent: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    [theme.breakpoints.only('sm')]: {
      minWidth: 180,
      marginLeft: -4,
      marginRight: -4,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 200,
    }
  },
  boxContentDD: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
  },
  boxContentButton: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    minHeight: 48,
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  boxContentButtonSelected: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      border: '1px solid '+ ColorTheme,
      margin: 8,
    },
  },
  boxContentButtonDisabled: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    opacity: 0.6,
    minHeight: 48,
  },
  campaignImagePickerPlaceholder: {
    width: 88,
    height: 50,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
});

class ManageActivityReferralRewards extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.minOfferValidity = 0;
    this.offerValidity = 0;
    if (activityData.activityConfigs) {
      this.minOfferValidity = activityData.activityConfigs.minOfferValidity;
      this.offerValidity = activityData.activityConfigs.offerValidity;
    }

    this.enableLoyaltyReward = activityData.usageType === constants.activity.usageTypes.LOYALTY;
    this.maxWinOffersCount = 1; // set to 1 only

    if (activityData.referralWinFun && !activityData.referralWinFun.business) {
      activityData.referralWinFun.business = activityData.business;
    }
    const rewardsData = {
      winPoints: activityData.referralWinPoints,
      offers: activityData.referralWinFun ? [activityData.referralWinFun] : null,
    };
    let rewardState = activityData.referralRewardState;
    if (!activityData.isReferralRewardStateUpdated) {
      rewardState = constants.activity.state.DELETE;
      if (this.enableLoyaltyReward && activityData.referralWinPoints > 0) {
        rewardState = constants.activity.state.ACTIVE;
      } else if (activityData.referralWinFun) {
        rewardState = constants.activity.state.ACTIVE;
      }
    }

    this.rewardOption0 = {'id': 0, 'name': <FormattedMessage id='activity.manage.noRewards'/>};
    this.rewardOption2 = {'id': 2, 'name': <FormattedMessage id='activity.type.addNewOffer'/>};
    this.rewardOption3 = {'id': 3, 'name': <FormattedMessage id='activity.type.addNewVoucher'/>};

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.manage.sectionAddOffer', expand: true, expandAlways: true},
        {id: 2, labelId: 'activity.manage.sectionAddVoucher', expand: true, expandAlways: true},
        {id: 3, labelId: 'activity.manage.sectionRewards', subLabelId: 'activity.manage.hintAddRewardToList', expand: true, expandAlways: true},
      ],
      boxType: rewardState === constants.activity.state.DELETE ? 0 : 1,
      rewardState: rewardState,
      rewardsData: rewardsData,
      newReward: activityData.newReferralReward,
      newRewardError: null,
      isNewRewardAdded: false,
      activityRewarded: null,
      activityRewardedSearch: '',
      isActivityRewardedLoading: false,
      showValidationMsg: false,
      showNewRewardValidationMsg: false,
      rewardOptions: this.getRewardOptions(),
      reload: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    // this.fetchActivityWinRewards();
    if (!this.props.activityData.isReferralRewardStateUpdated) {
      this.props.onDataUpdated(this.getData(true));
    }
  }

  componentWillUnmount() {
    if (this.timeoutHandleId) {
      clearTimeout(this.timeoutHandleId);
    }
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields, onDone) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
      if (onDone) {
        onDone();
      }
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false, showNewRewardValidationMsg: false});
  }

  getRewardOptions() {
    const rewardOptions = [];
    if (!this.enableLoyaltyReward) {
      rewardOptions.push(this.rewardOption0);
    }
    // rewardOptions.push(this.rewardOption1);

    let showAddOffer = true;
    let showAddVoucher = true;
    // const firstOffer = rewardsData && rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0] : null;
    // if (firstOffer) {
    //   if (firstOffer.type === constants.activity.types.OFFER) {
    //     showAddVoucher = false;
    //   } else {
    //     showAddOffer = false;
    //   }
    // }
    if (showAddOffer) {
      rewardOptions.push(this.rewardOption2);
    }
    if (showAddVoucher) {
      rewardOptions.push(this.rewardOption3);
    }
    return rewardOptions;
  }

  getData(excludeError) {
    const {
      rewardState,
      rewardsData,
      newReward,
    } = this.state;
    const referralWinPoints = rewardsData.winPoints;
    const referralWinFun = rewardsData.offers ? rewardsData.offers[0] : null;

    if (!excludeError) {
      if (newReward) {
        this.setState({showValidationMsg: true});
        return false;
      }
      if (this.enableLoyaltyReward) {
        if (!referralWinPoints || ValueHelper.getEnglishValue(referralWinPoints) <= 0) {
          this.setState({showValidationMsg: true});
          return false;
        }
      }
      if (rewardState === constants.activity.state.ACTIVE && !referralWinFun) {
        this.setState({showValidationMsg: true});
        return false;
      }
    }

    return {
      isReferralRewardStateUpdated: true,
      referralRewardState: rewardState,
      referralWinFun,
      referralWinPoints,
      newReferralReward: newReward
    };
  }

  render() {
    const {app, activities, activityData, classes, isXS} = this.props;
    const {
      rewardOptions,
      rewardState,
      rewardsData,
      showValidationMsg,
      showNewRewardValidationMsg,
      sections,
      newReward,
      newRewardError,
      isBlockedLoading,
      loadingProgress
    } = this.state;

    let placeholderTitleId = null;
    let placeholderImageId = null;
    if (newReward) {
      if (newReward.type === constants.activity.types.OFFER) {
        placeholderTitleId = 'activity.manage.offerTitle';
        placeholderImageId = 'activity.manage.offerImage';
      } else if (newReward.type === constants.activity.types.VOUCHER) {
        placeholderTitleId = 'activity.manage.voucherTitle';
        placeholderImageId = 'activity.manage.voucherImage';
      }
    }
    const showWinLimit = false;
    const winRewardsError = showValidationMsg && (!rewardsData.offers || rewardsData.offers.length === 0);
    const winLimitError = null;
    const winGLimitError = null;

    const newRewardErrorEff = newRewardError || <FormattedMessage id={'activity.manage.saveRewardError'} />;
    const newRewardEndInDayError = (showValidationMsg || showNewRewardValidationMsg) && newReward && (!newReward.endInDay || ValueHelper.getEnglishValue(newReward.endInDay) < this.minOfferValidity);
    const newRewardVoucherError = (showValidationMsg || showNewRewardValidationMsg) && newReward && newReward.type === constants.activity.types.VOUCHER && newReward.vouchers.length === 0;
    const newRewardLoyaltyPointsError = (showValidationMsg || showNewRewardValidationMsg) && newReward && this.enableLoyaltyReward
      && (!newReward.fee || ValueHelper.getEnglishValue(newReward.fee) <= 0);

    let winPointsError = null;
    let topHintLabelId;
    let titleLoyaltyPoints;
    let hintLoyaltyPoints;

      // winPointsError = showValidationMsg && (!winPoints || ValueHelper.getEnglishValue(winPoints) <= 0);
      // topHintLabelId = activityData.usageType === constants.activity.usageTypes.LOYALTY ? 'activity.manage.topHintLoyaltyRewards' : 'activity.manage.topHintRewards';
      // titleLoyaltyPoints = 'activity.winPoints';
      // hintLoyaltyPoints = 'activity.hintLoyaltyPointsWinners';

    const extraHorizontalMargin = isXS ? 0 : 12;

    const inputSpace = FIELD_SPACE;
    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={classes.flexColumnNoCenter}>
          <SectionHeaderView labelId={isXS ? 'activity.tabReferralHint' : 'activity.manage.selectReward'}/>
          <div className={classes.viewRowFullWidth}>
            {rewardOptions.map((item, index) => {
              return this.getRewardOptionView(item);
            })}
          </div>
          <FieldSpace multiplier={2} />

          {rewardState === constants.activity.state.ACTIVE ?
            <div className={classes.formActivity}>
              {newReward && newReward.type ?
                <React.Fragment>
                  {this.getFormSectionHeaderView(sections[newReward.type === constants.activity.types.OFFER ? 0 : 1])}

                  <MediaPlaceholder labelId={'activity.imageObliqueVideo'}/>
                  <SingleFilePicker
                    required={false}
                    hideDropzoneText={true}
                    size={'small'}
                    filesLimit={1}
                    acceptedFiles={{...ACCEPTED_IMAGE_MIMES, ...ACCEPTED_VIDEO_MIMES}}
                    maxSizeMimes={{image: 20*1024*1024, video: 100*1024*1024}}
                    maxDurationMimes={{video: activityData.mediaConfigs.maxVideoDuration}}
                    maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
                    aspectRatio={4/3}
                    initialFiles={newReward.mediaFiles}
                    onChange={(files) => {
                      this.onChangeFiles(files, 'mediaUrl');
                    }}
                    onDelete={(file) => {
                      this.onDeleteFile(file, 'mediaUrl');
                    }}
                  />
                  <FieldSpace/>

                  <TextField
                    variant="filled"
                    fullWidth
                    required
                    autoFocus
                    size="small"
                    type="text"
                    id="name"
                    name="name"
                    label={<FormattedMessage id={placeholderTitleId}/>}
                    InputProps={{disableUnderline: true}}
                    inputProps={{maxLength: 200}}
                    value={newReward.name}
                    onChange={this.onChangeForReward}
                    error={(showValidationMsg || showNewRewardValidationMsg) && !newReward.name}
                    helperText={(showValidationMsg || showNewRewardValidationMsg) && !newReward.name &&
                      <FormattedMessage id='generic.validation.required'/>}
                  />
                  <FieldSpace/>

                  <TextField
                    multiline
                    rows={2}
                    rowsMax={isXS ? 4 : 6}
                    variant="filled"
                    fullWidth
                    size="small"
                    type="text"
                    id="description"
                    name="description"
                    label={<FormattedMessage id='activity.manage.description'/>}
                    InputProps={{disableUnderline: true}}
                    inputProps={{maxLength: 2000}}
                    value={newReward.description}
                    onChange={this.onChangeForReward}
                  />
                  <FieldSpace/>

                  {/*<TextField*/}
                  {/*  required*/}
                  {/*  variant="filled"*/}
                  {/*  fullWidth*/}
                  {/*  size="small"*/}
                  {/*  type="number"*/}
                  {/*  id="endInDay"*/}
                  {/*  name="endInDay"*/}
                  {/*  label={<FormattedMessage id={'activity.offerValidity'}/>}*/}
                  {/*  value={newReward.endInDay}*/}
                  {/*  InputProps={{disableUnderline: true}}*/}
                  {/*  inputProps={{min: 1, max: 365}}*/}
                  {/*  onChange={this.onChangeForReward}*/}
                  {/*  onKeyDown={textFieldIntegerOnKeyDown}*/}
                  {/*  error={(showValidationMsg || showNewRewardValidationMsg) && newRewardEndInDayError}*/}
                  {/*  helperText={(showValidationMsg || showNewRewardValidationMsg) && newRewardEndInDayError ? <FormattedMessage id='activity.validation.requiredValueOrMore' values={{value: this.minOfferValidity}} /> : <FormattedMessage id={'activity.hintOfferValidity'} />}*/}
                  {/*/>*/}
                  {/*<FieldSpace/>*/}

                  {activityData.usageType === constants.activity.usageTypes.LOYALTY ?
                    <React.Fragment>
                      <TextField
                        required
                        variant="filled"
                        fullWidth
                        size="small"
                        type="number"
                        id="fee"
                        name="fee"
                        label={<FormattedMessage id='activity.manage.loyaltyRewardFee'/>}
                        InputProps={{disableUnderline: true}}
                        inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                        value={newReward.fee}
                        onChange={this.onChangeForReward}
                        onKeyDown={textFieldIntegerOnKeyDown}
                        error={newRewardLoyaltyPointsError}
                        helperText={newRewardLoyaltyPointsError ? <FormattedMessage id='activity.requiredLoyaltyPointsToRedeem' /> : null}
                      />
                      <FieldSpace/>
                    </React.Fragment>
                    : null
                  }

                  {newReward.type === constants.activity.types.VOUCHER ?
                    <React.Fragment>
                      {/*<div className={newRewardVoucherError ? classes.viewVouchersError : classes.flexColumnNoCenter}>*/}
                      <SectionHeaderView labelId={'activity.manage.vouchersCodes'} subLabelId={'activity.manage.hintEnterVoucherCode'} />
                      {/*<InputLabel required error={newRewardVoucherError} style={{color: newRewardVoucherError ? ColorNegative : ColorTheme, paddingLeft: 12, paddingRight: 12}}>{<FormattedMessage id={'activity.manage.vouchersCodes'} />}</InputLabel>*/}
                      {/*<FormHelperText style={{paddingLeft: 12, paddingRight: 12, marginTop: 0}}>{<FormattedMessage id={'activity.manage.hintEnterVoucherCode'} />}</FormHelperText>*/}
                      <div className={classes.flexRowNoCenter}>
                        <div className={classes.flexColumn}>
                          <TextField
                            variant="filled"
                            required={newReward.type === constants.activity.types.VOUCHER && (!newReward.vouchers || newReward.vouchers.length === 0)}
                            fullWidth
                            multiline
                            rows={1}
                            rowsMax={8}
                            size="small"
                            type="text"
                            id="newVoucher"
                            name="newVoucher"
                            label={<FormattedMessage id={'activity.manage.enterVoucherCode'} />}
                            InputProps={{disableUnderline: true}}
                            inputProps={{maxLength: 100}}
                            value={newReward.newVoucher}
                            onChange={this.onChangeForReward}
                            error={newRewardVoucherError}
                            helperText={newRewardVoucherError ? <FormattedMessage id={'activity.manage.atleastOneVocuherNeeded'} /> : null}
                          />
                        </div>
                        <Space vertical={12}/>
                        <div className={classes.viewColumn}>
                          <Button
                            disableElevation
                            size={isXS ? 'medium' : 'large'}
                            disabled={!newReward.newVoucher || newReward.newVoucher.trim().length === 0}
                            variant={'outlined'}
                            color="primary"
                            className={classes.buttonCamelCase}
                            // style={{minHeight: 48}}
                            onClick={this.onAddNewVoucherClicked}>
                            {<FormattedMessage id={'activity.manage.addCode'}/>}
                          </Button>
                        </div>
                      </div>
                      <Space horizontal={8}/>

                      <div className={classes.viewVouchersListField}>
                        {/*<InputLabel style={{color: ColorTheme}}>{<FormattedMessage id={'activity.manage.vouchersList'} />}</InputLabel>*/}
                        {/*<FormHelperText style={{marginTop: -6, color: ColorTheme}}>{<FormattedMessage id={'activity.manage.hintAddVoucherToList'} />}</FormHelperText>*/}
                        {/*<Space horizontal={8} />*/}
                        {newReward.vouchers && newReward.vouchers.length > 0 ?
                          <div className={classes.viewFullWidthWrap} style={{margin: -4, marginLeft: 0, marginRight: -8, paddingLeft: 2, paddingRight: 2, paddingBottom: 4}}>
                            {newReward.vouchers.map((voucher, index) => {
                              let chipName = voucher.code;
                              return (
                                <Chip
                                  size={'medium'}
                                  key={voucher.id}
                                  style={{minHeight: 32, marginTop: 4, marginBottom: 4, marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, overflow: 'hidden', borderRadius: BORDER_RADIUS}}
                                  label={<TextView numberOfLines={1} variant={'body1'} style={{minHeight: 32, whiteSpace: 'normal', paddingTop: 6, paddingBottom: 6}}>{chipName}</TextView>}
                                  onDelete={this.onDeleteVoucher.bind(this, voucher, index)}
                                />
                              );
                            })}
                          </div>
                          : null
                        }
                      </div>
                      {/*{newRewardVoucherError ? <FormHelperText className={classes.helperError} style={{paddingLeft: 12, paddingRight: 12}}>{<FormattedMessage id={'activity.manage.atleastOneVocuherNeeded'} />}</FormHelperText> : null}*/}
                      {/*</div>*/}
                      <FieldSpace />
                    </React.Fragment>
                    : null
                  }

                  <FieldSpace multiplier={0.2} />
                  <div className={classes.viewRowNoCenter}>
                    <FormControl
                      required
                      size="small">
                      <Button
                        disableElevation
                        size={isXS ? 'medium' : 'large'}
                        variant={"outlined"}
                        color="secondary"
                        onClick={this.onCancelRewardClicked}>
                        {<FormattedMessage id={'activity.manage.cancelReward'}/>}
                      </Button>
                    </FormControl>
                    {newReward.type ? <FieldSpace vertical={true} /> : null}
                    {newReward.type ?
                      <FormControl
                        required
                        size="small">
                        <Button
                          disableElevation
                          size={isXS ? 'medium' : 'large'}
                          variant={'contained'}
                          color="primary"
                          onClick={this.onSaveRewardClicked}>
                          {<FormattedMessage id={'activity.manage.saveReward'}/>}
                        </Button>
                      </FormControl>
                      : null
                    }
                  </div>
                  <Space horizontal={6}/>
                  {isBlockedLoading && <ProgressLoader progress={loadingProgress} />}
                  {showValidationMsg ? <TextView variant={'body2'} aling={'left'} color={ColorNegative} style={{alignSelf: 'flex-start', marginLeft: 12, marginRight: 12}}>{newRewardErrorEff}</TextView> : null}
                  <FieldSpace/>
                </React.Fragment>
                : null
              }

              {rewardsData.offers && rewardsData.offers.length > 0 ?
                <React.Fragment>
                  <div className={classes.viewRowNoCenter} style={{minWidth: 300, maxWidth: isXS ? 410 : 360}}>
                    <SectionHeaderView labelId={rewardsData.offers[0].type === constants.activity.types.VOUCHER ? 'activity.type.voucher' : 'activity.type.offer'} />
                    <Button onClick={this.onDeletedReward.bind(this, rewardsData.offers[0], 0)} size={'small'} className={classes.negativeButton} style={{marginBottom: 4}}>
                      <FormattedMessage id={'remove'}/>
                    </Button>
                  </div>
                  <div>
                    <div style={{minWidth: 300, maxWidth: isXS ? 410 : 360, height: 200, position: 'relative'}}>
                      <GetViewForItem disabled={true} hideAction={true} isXS={isXS} item={rewardsData.offers[0]} isLTR={app.isLTR} classes={classes} />
                    </div>
                    <Space horizontal={4}/>
                    <TextView color={'textSecondary'} variant={'caption'} align={'left'} className={classes.typoNormal} style={{paddingLeft: 12, paddingRight: 12}}>
                      <FormattedMessage id={'activity.editRewardInMyRewards'}/>
                    </TextView>
                  </div>
                  <FieldSpace/>
                </React.Fragment>

                // <div className={classes.formActivitySmall} style={{padding: 0, marginTop: -inputSpace/2}}>
                //   <div className={winRewardsError ? classes.viewRewardsListError : classes.viewVouchersListField} >
                //     <div className={classes.flexColumnNoCenter}>
                //       <div className={classes.expandCollapseBar}>
                //         <div className={classes.buttonBaseAppDisabled} style={{minHeight: 48}}>
                //           <div className={classes.flexRow}>
                //             <Space vertical={16} />
                //             <div className={classes.viewColumnFullWidthNoCenter}>
                //               <div className={classes.flexRow} style={{minHeight: 48}}>
                //                 <InputLabel required={false} error={winRewardsError} style={{fontWeight: 'bold', color: winRewardsError ? ColorNegative : ColorTheme}}>{<FormattedMessage id={this.maxWinOffersCount === 1 ? 'activity.sectionReward' : 'activity.manage.sectionRewards'} />}</InputLabel>
                //               </div>
                //               {this.maxWinOffersCount > 1 || !rewardsData.offers || rewardsData.offers.length === 0 ?
                //                 <Typography color={'textSecondary'} variant={'caption'} align={'left'} className={classes.typoNormal} style={{marginTop: -12, marginBottom: 8}}>
                //                   <FormattedMessage id={this.maxWinOffersCount === 1 ? 'activity.hintAddRewardToList' : 'activity.manage.hintAddRewardsToList'} />
                //                 </Typography>
                //                 : null
                //               }
                //             </div>
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //
                //     <Space horizontal={8} />
                //     <div className={classes.flexColumnNoCenter} style={{padding: 16, paddingTop: 8}}>
                //       {rewardsData.offers && rewardsData.offers.length > 0 ?
                //         <div className={classes.viewColumnFullWidthNoCenter} style={{marginTop: -4, marginBottom: 4}}>
                //           {rewardsData.offers.map((option, index) => {
                //             let chipName = option.name;
                //             return (
                //               <div>
                //                 <Chip
                //                   size={'medium'}
                //                   variant={'outlined'}
                //                   color={'primary'}
                //                   key={option.id}
                //                   style={{height: '100%', minHeight: 32, marginTop: 4, marginBottom: 4}}
                //                   label={<Typography variant={'subtitle1'} style={{minHeight: 32, whiteSpace: 'normal', padding: 4}}>{chipName}</Typography>}
                //                   onDelete={this.onDeletedReward.bind(this, option, index)}
                //                 />
                //               </div>
                //             );
                //           })}
                //         </div>
                //         : null
                //       }
                //       {winRewardsError ? <FormHelperText className={classes.helperError} style={{marginTop: 6}}>{<FormattedMessage id={this.enableLoyaltyReward ? 'activity.manage.atleastOneLoyaltyRewardNeeded' : 'activity.manage.atleastOneRewardNeeded'} />}</FormHelperText> : null}
                //     </div>
                //   </div>
                // </div>
                : null
              }
            </div>
            :null
          }
        </div>
      </div>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : null}
        </MuiAlert>
      </Snackbar>
    );
  }

  showSnackbar(messageId) {
    this.setState({
      snackbarMessageId: messageId,
      snackbarType: 'success'
    });
  }

  getRewardOptionView(item) {
    const {classes, activities, app} = this.props;
    const {boxType, newReward, rewardsData, winPoints, isActivityRewardedLoading, activityRewardedSearch} = this.state;

    let titleId = null;
    let isSelected = false;
    let isDisabled = false;
    let type = 0;
    if (item.id === 0) {
      isSelected = item.id === boxType && boxType === 0;
      isDisabled = newReward != null || (!isSelected && rewardsData.offers && rewardsData.offers.length > 0);
      titleId = item.name;
      type = 0;
    } else if (item.id === 2 || item.id === 3) {
      type = item.id === 2 ? constants.activity.types.OFFER : constants.activity.types.VOUCHER;
      // titleId = type === constants.activity.types.OFFER ? 'activity.manage.addNewOffer' : 'activity.manage.addNewVoucher';
      // if (boxType === 1) {
      // titleId = type === constants.activity.types.OFFER ? 'activity.type.offer' : 'activity.type.voucher';
      // }
      titleId = type === constants.activity.types.OFFER ? 'activity.type.offer' : 'activity.type.voucher';
      const firstOffer = rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0] : null;
      if (firstOffer) {
        if (firstOffer.isVoucher) {
          firstOffer.type = constants.activity.types.VOUCHER;
        }
        isSelected = firstOffer.type == type;
      } else if (newReward) {
        isSelected = newReward.type == type;
      }
      isDisabled = (newReward != null && newReward.type != type) || (!isSelected && firstOffer && firstOffer.type != type);
      const isDisabledClick = newReward != null || firstOffer;
      // return (
      //   <ButtonBase
      //     disabled={isDisabledClick}
      //     onClick={this.onAddRewardClicked.bind(this, item, type)}
      //     className={isDisabled ? classes.boxesCardRewardDisabled : isSelected ? classes.boxesCardRewardSelected : classes.boxesCardReward}
      //     focusVisibleClassName={classes.focusVisible}>
      //     <div className={classes.boxContent}>
      //       <Typography variant="subtitle1" color="primary" align={'left'} style={{fontWeight: isSelected ? FONT_WEIGHT_BOLD : FONT_WEIGHT_MEDIUM}}>
      //         <FormattedMessage id={titleId} />
      //       </Typography>
      //       {/*{item.details ?*/}
      //       {/*  <Typography variant="caption" color="textSecondary" align={'left'}>*/}
      //       {/*    {item.details}*/}
      //       {/*  </Typography>*/}
      //       {/*  : null*/}
      //       {/*}*/}
      //     </div>
      //     {isSelected ?
      //       <div className={classes.cardCheck}>
      //         <CheckCircleIcon style={{color: ColorTheme}}/>
      //       </div>
      //       : null
      //     }
      //   </ButtonBase>
      // );
    }
    const onClick = () => {
      if (!isSelected) {
        this.onAddRewardClicked(item, type);
      }
    };
    return (
      <Button
        disabled={isDisabled}
        color={isSelected ? 'primary' : 'secondary'}
        size={this.props.isXS ? 'medium' : 'large'}
        variant={"outlined"}
        onClick={onClick}
        style={{marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0}}
        className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
        startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
        <FormattedMessage id={titleId} />
      </Button>
    );

    // if (item.id === 1) {
    //   return (
    //     <ButtonBase
    //       onClick={this.onRewardOptionSelected.bind(this, item)}
    //       className={item.id === boxType ? classes.boxesCardReward : classes.boxesCardReward}
    //       focusVisibleClassName={classes.focusVisible}>
    //       <div className={classes.boxContentDD}>
    //         <Typography variant="subtitle1" color="primary" align={'left'} style={{fontWeight: item.id === boxType ? FONT_WEIGHT_BOLD : FONT_WEIGHT_MEDIUM, marginLeft: 4, marginRight: 4}}>
    //           {item.name}
    //         </Typography>
    //         <Space horizontalSpace={2}/>
    //         <div className={classes.viewColumnFullWidthNoCenter}>
    //           <AutoCompleteView
    //             ref={(ref) => this.refSelectRewards = ref}
    //             fullWidth
    //             variant="outlined"
    //             label={this.context.intl.formatMessage({id: 'activity.manage.selectReward'})}
    //             placeholder={this.context.intl.formatMessage({id: 'activity.manage.searchNSelectReward'})}
    //             loading={isActivityRewardedLoading}
    //             options={activities.activity.data.winRewards}
    //             // selectedValues={activityRewarded}
    //             inputValue={activityRewardedSearch}
    //             onInputChange={this.onChangeActivityRewarded}
    //             onSelect={this.onSelectActivityRewarded}
    //           />
    //         </div>
    //       </div>
    //     </ButtonBase>
    //   );
    // }
  }

  onAddNewVoucherClicked = () => {
    const {newReward} = this.state;
    const {vouchers, newVoucher} = newReward;
    if (newVoucher && newVoucher.trim().length > 0) {
      const newVoucherCopy = {
        id: -(new Date().getMilliseconds()),
        code: newVoucher.trim(),
        quantity: 1,
      };
      vouchers.splice(0, 0, newVoucherCopy);
      newReward.vouchers = vouchers;
      newReward.newVoucher = '';
    }
    this.updateState({newReward, newVoucher: '', showNewRewardValidationMsg: false});
  };

  onDeleteVoucher = (voucher, index) => {
    const {newReward} = this.state;
    newReward.vouchers.splice(index, 1);
    this.updateState({newReward, showNewRewardValidationMsg: false});
  };

  onAddRewardClicked = (item, type) => {
    const {activityData} = this.props;
    this.onRewardOptionSelected(item, () => {
      const {newReward} = this.state;
      if (!newReward || newReward.type !== type) {
        const newReward = {
          type: type,
          usageType: activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : 0,
          endInDay: this.offerValidity,
          fee: '',
          imageUrl: null,
          initialFiles: [],
        };
        if (type === constants.activity.types.VOUCHER) {
          newReward.newVoucher = '';
          newReward.vouchers = [];
        }
        this.updateState({newReward, showNewRewardValidationMsg: false});
      }
    });
    // // action is delayed to process the parent action first and then this one
    // setTimeout(() => {
    //   const {newReward} = this.state;
    //   if (!newReward || newReward.type !== type) {
    //     const newReward = {
    //       type: type,
    //       usageType: activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : 0,
    //       endInDay: this.offerValidity,
    //       fee: '',
    //       imageUrl: null,
    //       initialFiles: [],
    //     };
    //     if (type === constants.activity.types.VOUCHER) {
    //       newReward.newVoucher = '';
    //       newReward.vouchers = [];
    //     }
    //     this.setState({newReward, showNewRewardValidationMsg: false});
    //   }
    // }, 100);
  };

  onRewardOptionSelected = (item, onDone) => {
    const {activityData} = this.props;
    const {boxType, newReward, winPoints, rewardState, rewardsData} = this.state;
    const newRewardState = item.id === constants.activity.state.DELETE ? 0 : 1;
    if (newRewardState !== rewardState) {
      let rewardState;
      let winLimit;
      let winGLimit;
      const winPoints = this.enableLoyaltyReward ? winPoints : 0;
      const activityRewardedSearch = null;
      rewardsData.offers = [];
      if (newRewardState) {
        rewardState = constants.activity.state.ACTIVE;
        winLimit = 0;
        winGLimit = '';
      } else {
        rewardState = constants.activity.state.DELETE;
        winLimit = 0;
        winGLimit = 0;
      }
      this.updateState({
        boxType: item.id,
        showValidationMsg: false,
        rewardState: rewardState,
        rewardsData,
        newReward: boxType !== item.id ? null : newReward,
        winLimit,
        winGLimit,
        winPoints,
        activityRewardedSearch,
        // rewardOptions: this.getRewardOptions(rewardsData),
        showNewRewardValidationMsg: false
      }, onDone);
    } else {
      this.updateState({boxType: item.id, showValidationMsg: false, newReward: boxType !== item.id ? null : newReward}, onDone);
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onFormSectionToggle = (section) => {
    let {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    const newState = !eSections[index].expand;
    eSections[index].expand = newState;
    let newReward = null;
    if (newState) {
      newReward = {
        type: 0,
        name: '',
        imageUrl: null,
        imageFiles: null,
      };
    }
    if (this.timeoutHandleId) {
      clearTimeout(this.timeoutHandleId);
    }
    this.setState({sections: eSections, newReward, isNewRewardAdded: false, showValidationMsg: false, showNewRewardValidationMsg: false});
  }

  onChangeFiles(files, id) {
    let {newReward} = this.state;
    const {mediaUrl} = newReward;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    newReward[keyImageUrl] = lFileUrl;
    newReward[keyImageFiles] = lFiles;
    this.updateState({showValidationMsg: false, showNewRewardValidationMsg: false, newReward});
  }

  onDeleteFile(file, id) {
    let {newReward} = this.state;
    const {mediaUrl, mediaFiles} = newReward;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    newReward[keyImageUrl] = lFileUrl;
    newReward[keyImageFiles] = lFiles;
    newReward[keyIsImageDeleted] = true;
    this.updateState({showValidationMsg: false, showNewRewardValidationMsg: false, newReward});
  }

  onChange = (event) => {
    const {rewardState, rewardsData} = this.state;
    let rewardStateEff = rewardState;
    let value = event.target.value;
    if (event.target.name === 'winPoints') {
      const maxValue = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
      if (!value && value !== 0) {
        value = '';
      }
      if (event.target.name === 'winPoints') {
        if (value > 0) {
          rewardStateEff = constants.activity.state.ACTIVE;
        } else {
          rewardStateEff = constants.activity.state.INACTIVE;
        }
      }
      rewardsData.winPoints = value;
    }

    this.updateState({[event.target.name]: value,
      rewardState: rewardStateEff,
      rewardsData: rewardsData,
      showValidationMsg: false,
      showNewRewardValidationMsg: false});
  };

  onChangeActivityRewarded = (value) => {
    if (value.length > 1) {
      this.updateState({activityRewardedSearch: value, activityRewarded: null, isActivityRewardedLoading: true, showValidationMsg: false, showNewRewardValidationMsg: false});
      this.fetchActivityWinRewards(value);
    } else {
      this.updateState({activityRewardedSearch: value, activityRewarded: null, showValidationMsg: false, showNewRewardValidationMsg: false});
    }
  };

  onSelectActivityRewarded = (value) => {
    const {rewardsData} = this.state;
    const offers = rewardsData.offers || [];
    let isNew = true;
    if (value) {
      offers.forEach((offer) => {
        if (value.id === offer.id) {
          isNew = false;
        }
      });
      if (isNew) {
        offers.push(value);
        if (offers.length > this.maxWinOffersCount) {
          offers.splice(0, 1);
        }
      }
    }
    rewardsData.offers = offers;
    this.setState({
      activityRewardedSearch: value ? value.name : '',
      rewardsData: rewardsData,
      showValidationMsg: false,
      showNewRewardValidationMsg: false,
      isActivityRewardedLoading: false,
    });
    if (value) {
      this.showInfoBar('activity.manage.rewardSelected');
    }
  };

  onDeletedReward = (reward, index) => {
    let {rewardsData, winPoints, boxType, rewardState, rewardOptions} = this.state;
    if (reward.id === -1) {
      rewardsData.winPoints = '';
    }
    if (rewardsData.offers) {
      rewardsData.offers.splice(index, 1);
    }

    if (rewardsData.offers.length === 0) {
      rewardState = constants.activity.state.DELETE;
      boxType = 0;
      // rewardOptions = this.getRewardOptions(rewardsData);
    }

    this.updateState({rewardsData: rewardsData,
      showValidationMsg: false,
      showNewRewardValidationMsg: false,
      rewardState,
      boxType,
      rewardOptions
    });
  };

  onChangeForReward = (event) => {
    const {newReward} = this.state;
    let value = event.target.value;
    if (event.target.name === 'fee' || event.target.name === 'endInDay') {
      const maxValue = event.target.name === 'endInDay' ? 365 : constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }
    newReward[event.target.name] = value;
    this.setState({newReward: newReward, showValidationMsg: false, showNewRewardValidationMsg: false});
  };

  onCancelRewardClicked = () => {
    this.updateState({newReward: null, showNewRewardValidationMsg: false,
      rewardState: constants.activity.state.DELETE, boxType: 0});
  }

  onSaveRewardClicked = () => {
    const {activityData} = this.props;
    const {newReward, rewardsData} = this.state;
    if (!newReward || !newReward.type || !newReward.name
      || (!newReward.endInDay || ValueHelper.getEnglishValue(newReward.endInDay) < this.minOfferValidity)
      || (newReward.type === constants.activity.types.VOUCHER && (!newReward.vouchers || newReward.vouchers.length === 0))
      || (newReward.usageType === constants.activity.usageTypes.LOYALTY && (!newReward.fee || ValueHelper.getEnglishValue(newReward.fee) <= 0))) {
      this.setState({showNewRewardValidationMsg: true});
      return;
    }

    const data = {
      type: constants.activity.types.OFFER,
      usageType: activityData.usageType,
      endInDay: newReward.endInDay,
      fee: newReward.fee ? ValueHelper.getEnglishValue(newReward.fee) : 0,
      createdForId: activityData.business.id,
      startAt: activityData.startAt.toJSON(),
      endAt: activityData.endAt.toJSON(),
      title: newReward.name,
      consumableAt: newReward.type === constants.activity.types.VOUCHER ? 10 : 0,
    };
    if (newReward.description) {
      data.description = newReward.description;
    }
    if (newReward.vouchers && newReward.vouchers.length > 0) {
      const vouchers = [];
      newReward.vouchers.forEach((voucher) => {
        vouchers.push(JSON.stringify(voucher));
      });
      data.vouchers = vouchers;
    }
    let videoFiles = null, imageFiles = null;
    if (newReward.mediaFiles && newReward.mediaFiles.length > 0) {
      if (newReward.mediaFiles[0].type === FILE_TYPE_VIDEO) {
        videoFiles = newReward.mediaFiles;
      } else if (newReward.mediaFiles[0].type === FILE_TYPE_IMAGE) {
        imageFiles = newReward.mediaFiles;
      }
    }
    let files = [];
    if (imageFiles && imageFiles.length > 0) {
      files.push({'id': 'imageFile', 'file': imageFiles[0].file});
    }
    if (videoFiles && videoFiles.length > 0) {
      files.push({'id': 'videoFile', 'file': videoFiles[0].file});
    }
    const hasFiles = files && files.length > 0;
    if (hasFiles) {
      files.forEach((file) => {
        data[file.id] = file.file;
      });
    }
    this.setState({showValidationMsg: false, showNewRewardValidationMsg: false, newRewardError: null, isBlockedLoading: true, loadingProgress: 0});
    this.props.addNewRewardInActivity(data, (progressEvent) => {
      if (hasFiles) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (this.state.loadingProgress !== percentCompleted) {
          this.setState({loadingProgress: percentCompleted});
        }
      }
    }).then((response) => {
      if (response) {
        const newData = response.data;
        if (!newData.business) {
          newData.business = activityData.business;
        }

        const offers = rewardsData.offers || [];
        offers.splice(0, 0, newData);
        if (offers.length > this.maxWinOffersCount) {
          offers.splice(offers.length - 1, 1);
        }
        rewardsData.offers = offers;
        this.updateState({
          rewardsData: rewardsData,
          showValidationMsg: false,
          showNewRewardValidationMsg: false,
          newReward: null,
          isNewRewardAdded: true,
        });
        this.setState({isBlockedLoading: false});
        this.showSnackbar('activity.manage.rewardAddedSnack');
      }
    }).catch((response) => {
      const errorMessage = getErrorFromResponse(response, this.context.intl);
      this.setState({showValidationMsg: true, newRewardError: errorMessage, isBlockedLoading: false});
    });
  };

  fetchActivityWinRewards(value) {
    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout);
    }
    this.clearTimeout = setTimeout(() => {
      const {activityData} = this.props;
      const usageType = activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : null;
      this.props.fetchActivityWinRewards(value, usageType).then(() => {
        this.updateState({isActivityRewardedLoading: false});
      });
    }, 200);
  }
}

ManageActivityReferralRewards.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchActivityWinRewards: PropTypes.func,
  addNewRewardInActivity: PropTypes.func,
};

ManageActivityReferralRewards.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivityWinRewards: (search, usageType) => dispatch(fetchActivityWinRewards(search, usageType)),
    addNewRewardInActivity: (data, onUploadProgress) => dispatch(addNewRewardInActivity(data, onUploadProgress)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityReferralRewards))
);
